// Fix for product variant selection, accessories selection, and checkout
(function() {
  // Initialize fixes when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFixes);
  } else {
    // DOM is already ready, but wait a bit for dynamic content
    setTimeout(initializeFixes, 100);
  }
  
  // Also initialize on window load to catch any late-loading elements
  window.addEventListener('load', function() {
    setTimeout(initializeFixes, 500);
  });
  
  let initialized = false;
  
  function initializeFixes() {
    if (initialized) return;
    initialized = true;
    
    console.log('Initializing product fixes...');
    
    // Apply all fixes
    fixVariantSelection();
    fixAccessoriesSelection();
    fixCheckoutButton();
    
    // Monitor for dynamic changes
    observeChanges();
    
    console.log('Product fixes initialized');
  }

  // Fix 1: Variant Selection - Ensure variant changes update price and images
  function fixVariantSelection() {
    const variantRadios = document.querySelectorAll('.as-step-option');
    const variantDropdown = document.querySelector('.as-product-variant');
    
    // Handle radio button variant changes
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function(e) {
        if (this.checked) {
          updateVariantFromOptions();
        }
      });
    });
    
    // Handle dropdown variant changes
    if (variantDropdown) {
      variantDropdown.addEventListener('change', function() {
        handleVariantChange();
      });
    }
  }
  
  // New function to update variant based on selected options
  function updateVariantFromOptions() {
    // Get all selected option values
    const selectedOptions = [];
    const optionInputs = document.querySelectorAll('.as-step-option:checked');
    
    optionInputs.forEach(input => {
      selectedOptions.push(input.value);
    });
    
    if (selectedOptions.length === 0) return;
    
    // Get variant data
    const variantDataScript = document.querySelector('.as-variants-data');
    if (!variantDataScript) return;
    
    const variants = JSON.parse(variantDataScript.textContent);
    
    // Find matching variant based on selected options
    const matchingVariant = variants.find(variant => {
      // First, try to match by title (for cases like "Rokid Max 2 AR Glasses Black")
      if (selectedOptions.length === 1 && variant.title === selectedOptions[0]) {
        console.log('Found variant by title:', variant);
        return true;
      }
      
      // Otherwise, check if all selected options match this variant's options
      const variantOptions = [];
      if (variant.option1) variantOptions.push(variant.option1);
      if (variant.option2) variantOptions.push(variant.option2);
      if (variant.option3) variantOptions.push(variant.option3);
      
      // Check if selected options match variant options
      const matches = selectedOptions.every(option => 
        variantOptions.some(variantOption => variantOption === option)
      ) && selectedOptions.length === variantOptions.filter(opt => opt).length;
      
      if (matches) {
        console.log('Found variant by options:', variant);
      }
      
      return matches;
    });
    
    console.log('Selected options:', selectedOptions);
    console.log('Available variants:', variants);
    console.log('Matching variant:', matchingVariant);
    
    if (matchingVariant) {
      // Update the hidden select dropdown
      const variantSelect = document.querySelector('.as-product-variant');
      if (variantSelect) {
        variantSelect.value = matchingVariant.id;
        
        // Trigger change event
        const event = new Event('change', { bubbles: true });
        variantSelect.dispatchEvent(event);
      }
    }
  }

  function handleVariantChange() {
    // Get current variant data
    const variantSelect = document.querySelector('.as-product-variant');
    const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
    const variantId = selectedVariant.value;
    
    // Get variant data from JSON
    const variantDataScript = document.querySelector('.as-variants-data');
    if (!variantDataScript) return;
    
    const variants = JSON.parse(variantDataScript.textContent);
    const currentVariant = variants.find(v => v.id == variantId);
    
    if (currentVariant) {
      // Update price
      updatePrice(currentVariant);
      
      // Update main image
      updateProductImage(currentVariant);
      
      // Update form inputs
      updateFormInputs(currentVariant);
      
      // Update buy now button
      updateBuyNowButton(currentVariant);
      
      // Trigger custom event
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: currentVariant }
      }));
    }
  }

  function updatePrice(variant) {
    // Update main price
    const priceElements = document.querySelectorAll('.as-product-price, .product-price .price-item--regular');
    priceElements.forEach(el => {
      if (el) {
        el.textContent = formatMoney(variant.price);
      }
    });
    
    // Update compare price
    const comparePriceElements = document.querySelectorAll('.as-product-compare-at-price, .price-item--sale');
    comparePriceElements.forEach(el => {
      if (variant.compare_at_price > variant.price) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.classList.remove('d-none');
      } else {
        el.classList.add('d-none');
      }
    });
    
    // Update availability
    const soldOutElements = document.querySelectorAll('.as-sale-out-text');
    const addToCartButtons = document.querySelectorAll('button[name="add"]');
    const buyNowButtons = document.querySelectorAll('.as-checkout-btn, .buy-now-btn');
    
    if (variant.available) {
      soldOutElements.forEach(el => el.classList.add('d-none'));
      addToCartButtons.forEach(btn => {
        btn.disabled = false;
        const availableText = btn.querySelector('.as-available-info');
        const unavailableText = btn.querySelector('.as-unavailable-info');
        if (availableText) availableText.classList.remove('d-none');
        if (unavailableText) unavailableText.classList.add('d-none');
      });
      buyNowButtons.forEach(btn => {
        btn.classList.remove('d-none');
        btn.removeAttribute('disabled');
      });
    } else {
      soldOutElements.forEach(el => el.classList.remove('d-none'));
      addToCartButtons.forEach(btn => {
        btn.disabled = true;
        const availableText = btn.querySelector('.as-available-info');
        const unavailableText = btn.querySelector('.as-unavailable-info');
        if (availableText) availableText.classList.add('d-none');
        if (unavailableText) unavailableText.classList.remove('d-none');
      });
      buyNowButtons.forEach(btn => {
        btn.classList.add('d-none');
        btn.setAttribute('disabled', 'true');
      });
    }
  }

  function updateProductImage(variant) {
    // Hide all media galleries
    const allGalleries = document.querySelectorAll('media-gallery');
    allGalleries.forEach(gallery => {
      gallery.classList.add('d-none');
    });
    
    // Show the gallery for the selected variant
    const selectedGallery = document.querySelector(`media-gallery[data-variant-id="${variant.id}"]`);
    if (selectedGallery) {
      selectedGallery.classList.remove('d-none');
    }
    
    // Fallback: Update featured image if variant has one and no gallery switching
    if (!selectedGallery && variant.featured_image) {
      const mainImages = document.querySelectorAll('.media-gallery img[data-media-id], .featured-media img, .as-gallery-wrapper img');
      mainImages.forEach(img => {
        if (img.closest('.as-gallery-wrapper:not(.d-none)')) {
          img.src = variant.featured_image.src;
          img.srcset = variant.featured_image.src;
        }
      });
    }
  }

  function updateFormInputs(variant) {
    // Update hidden variant input
    const variantInputs = document.querySelectorAll('input[name="id"], .as-form-quantity');
    variantInputs.forEach(input => {
      input.value = variant.id;
    });
  }

  function updateBuyNowButton(variant) {
    const buyNowButtons = document.querySelectorAll('.as-checkout-btn, .buy-now-btn');
    buyNowButtons.forEach(btn => {
      const cartUrl = btn.dataset.cartUrl || '/cart';
      btn.href = `${cartUrl}/${variant.id}:1`;
      btn.dataset.variantId = variant.id;
    });
  }

  // Fix 2: Accessories Selection
  function fixAccessoriesSelection() {
    // Handle recommendations section
    const recommendationButtons = document.querySelectorAll('.as-recommendations-btn');
    const selectedRecommendations = new Set();
    
    recommendationButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const card = this.closest('.recommendations-card');
        const variantId = this.dataset.id;
        
        if (card.classList.contains('selected')) {
          // Deselect
          card.classList.remove('selected');
          selectedRecommendations.delete(variantId);
        } else {
          // Select
          card.classList.add('selected');
          selectedRecommendations.add(variantId);
        }
        
        // Update accessory count
        updateAccessoryCount(selectedRecommendations.size);
        
        // Update total price
        updateTotalPrice(selectedRecommendations);
      });
    });
    
    // Handle accessories-selection section (the product variants shown in screenshot)
    const accessoryItems = document.querySelectorAll('.as-item-accessories:not(.sold-out)');
    
    accessoryItems.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Only allow clicking if not sold out
        if (this.classList.contains('sold-out') || this.dataset.available === 'false') {
          return;
        }
        
        // Handle different types
        if (this.dataset.type === 'noRequired') {
          // "No accessories required" option - deselect all others
          document.querySelectorAll('.as-item-accessories').forEach(acc => {
            acc.classList.remove('active');
          });
          this.classList.add('active');
        } else {
          // Regular accessory - allow multiple selection
          // First, remove active from "no accessories" option
          const noAccessoriesOption = document.querySelector('.as-item-accessories[data-type="noRequired"]');
          if (noAccessoriesOption) {
            noAccessoriesOption.classList.remove('active');
          }
          
          // Toggle this item
          this.classList.toggle('active');
        }
        
        // Update selected accessories for checkout
        updateSelectedAccessoriesData();
      });
    });
  }

  function updateAccessoryCount(count) {
    const countElements = document.querySelectorAll('.accessory-count');
    countElements.forEach(el => {
      el.textContent = count > 0 ? ` + ${count} Accessories` : '';
    });
  }

  function updateSelectedAccessoriesData() {
    // Get all selected accessories
    const selectedAccessoryElements = document.querySelectorAll('.as-item-accessories.active:not([data-type="noRequired"])');
    const selectedAccessoryIds = new Set();
    
    selectedAccessoryElements.forEach(el => {
      const variantId = el.dataset.variantid;
      if (variantId) {
        selectedAccessoryIds.add(variantId);
      }
    });
    
    // Store in global variable for checkout
    window.selectedAccessoryVariants = selectedAccessoryIds;
    
    // Update count
    updateAccessoryCount(selectedAccessoryIds.size);
    
    // Update total price for accessories selection
    updateTotalPriceForAccessories(selectedAccessoryIds);
  }

  function updateTotalPrice(selectedAccessories) {
    // Get main product price
    const variantSelect = document.querySelector('.as-product-variant');
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const variantId = selectedOption.value;
    
    const variantDataScript = document.querySelector('.as-variants-data');
    const variants = JSON.parse(variantDataScript.textContent);
    const currentVariant = variants.find(v => v.id == variantId);
    
    let totalPrice = currentVariant ? currentVariant.price : 0;
    let totalComparePrice = currentVariant && currentVariant.compare_at_price ? currentVariant.compare_at_price : 0;
    
    // Add accessory prices
    selectedAccessories.forEach(accessoryId => {
      const button = document.querySelector(`.as-recommendations-btn[data-id="${accessoryId}"]`);
      if (button) {
        totalPrice += parseInt(button.dataset.price) || 0;
        if (button.dataset.compared) {
          totalComparePrice += parseInt(button.dataset.compared) || 0;
        }
      }
    });
    
    // Update total price display
    const totalPriceElements = document.querySelectorAll('.as-total-price-wrap .as-product-price');
    totalPriceElements.forEach(el => {
      el.textContent = formatMoney(totalPrice);
    });
    
    // Update total compare price
    const totalComparePriceElements = document.querySelectorAll('.as-total-price-wrap .as-product-compare-at-price');
    totalComparePriceElements.forEach(el => {
      if (totalComparePrice > totalPrice) {
        el.textContent = formatMoney(totalComparePrice);
        el.classList.remove('d-none');
      } else {
        el.classList.add('d-none');
      }
    });
  }

  // Fix 3: Checkout with all selected items
  function fixCheckoutButton() {
    // Override form submission to include accessories
    const productForms = document.querySelectorAll('product-form form');
    
    productForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Get selected accessories
        const selectedAccessories = [];
        document.querySelectorAll('.recommendations-card.selected .as-recommendations-btn').forEach(btn => {
          selectedAccessories.push({
            id: btn.dataset.id,
            quantity: 1
          });
        });
        
        // If add to cart button was clicked
        if (e.submitter && e.submitter.name === 'add') {
          addToCartWithAccessories(form, selectedAccessories);
        }
      });
    });
    
    // Fix buy now button
    document.addEventListener('click', function(e) {
      if (e.target.matches('.as-checkout-btn, .buy-now-btn')) {
        e.preventDefault();
        buyNowWithAccessories(e.target);
      }
    });
  }

  function updateTotalPriceForAccessories(selectedAccessoryIds) {
    // Get main product price
    const variantSelect = document.querySelector('.as-product-variant');
    if (!variantSelect) return;
    
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const variantId = selectedOption.value;
    
    const variantDataScript = document.querySelector('.as-variants-data');
    const variants = JSON.parse(variantDataScript.textContent);
    const currentVariant = variants.find(v => v.id == variantId);
    
    let totalPrice = currentVariant ? currentVariant.price : 0;
    
    // Add accessory prices
    selectedAccessoryIds.forEach(accessoryId => {
      const accessoryElement = document.querySelector(`.as-item-accessories[data-variantid="${accessoryId}"]`);
      if (accessoryElement && accessoryElement.dataset.price) {
        totalPrice += parseInt(accessoryElement.dataset.price) || 0;
      }
    });
    
    // Update total price display
    const totalPriceElements = document.querySelectorAll('.as-product-price');
    totalPriceElements.forEach(el => {
      if (el.closest('.as-total-price-wrap') || el.closest('.as-add-to-cart-wrap')) {
        el.textContent = formatMoney(totalPrice);
      }
    });
  }

  function addToCartWithAccessories(form, accessories) {
    const formData = new FormData(form);
    const items = [];
    
    // Add main product
    items.push({
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity')) || 1
    });
    
    // Add recommendations accessories
    accessories.forEach(acc => {
      items.push(acc);
    });
    
    // Add selected accessory variants
    if (window.selectedAccessoryVariants) {
      window.selectedAccessoryVariants.forEach(variantId => {
        items.push({
          id: variantId,
          quantity: 1
        });
      });
    }
    
    // Submit to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      // Trigger cart update event or show success message
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }

  function buyNowWithAccessories(button) {
    // Get main variant
    const variantId = button.dataset.variantId || button.href.match(/\/cart\/(\d+):/)?.[1];
    if (!variantId) return;
    
    // Get selected accessories from recommendations
    const accessories = [];
    document.querySelectorAll('.recommendations-card.selected .as-recommendations-btn').forEach(btn => {
      accessories.push(`${btn.dataset.id}:1`);
    });
    
    // Get selected accessory variants
    if (window.selectedAccessoryVariants) {
      window.selectedAccessoryVariants.forEach(variantId => {
        accessories.push(`${variantId}:1`);
      });
    }
    
    // Build cart URL with all items
    let cartUrl = `/cart/${variantId}:1`;
    if (accessories.length > 0) {
      cartUrl += ',' + accessories.join(',');
    }
    
    // Redirect to cart/checkout
    window.location.href = cartUrl;
  }

  // Helper function to format money
  function formatMoney(cents) {
    // Handle Shopify money format
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    
    // Fallback formatting
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  // Initialize variant change on page load
  setTimeout(() => {
    const event = new Event('change', { bubbles: true });
    const checkedRadio = document.querySelector('.as-step-option:checked');
    if (checkedRadio) {
      checkedRadio.dispatchEvent(event);
    }
  }, 100);

  // Monitor for dynamic changes
  function observeChanges() {
    // Watch for variant-options component updates
    const variantOptionsElement = document.querySelector('variant-options');
    if (variantOptionsElement) {
      // Check if variant-options is a custom element with its own methods
      if (variantOptionsElement.updateOptions) {
        console.log('Found variant-options custom element');
      }
      
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // Re-attach event listeners when DOM changes
            setTimeout(() => {
              fixVariantSelection();
              fixAccessoriesSelection();
            }, 50);
          }
        });
      });
      
      observer.observe(variantOptionsElement, {
        childList: true,
        subtree: true
      });
    }
    
    // Also watch for product-info content changes (for main-product-v3)
    const productInfoElement = document.querySelector('.purchase-main');
    if (productInfoElement) {
      const productObserver = new MutationObserver((mutations) => {
        let shouldReinit = false;
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && (
                node.classList?.contains('accessories-selection') ||
                node.querySelector?.('.accessories-selection')
              )) {
                shouldReinit = true;
              }
            });
          }
        });
        
        if (shouldReinit) {
          setTimeout(() => {
            fixAccessoriesSelection();
            fixCheckoutButton();
          }, 100);
        }
      });
      
      productObserver.observe(productInfoElement, {
        childList: true,
        subtree: true
      });
    }
    
    // Listen for various Shopify variant change events
    ['variant:switch', 'variant:change', 'variantChange'].forEach(eventName => {
      document.addEventListener(eventName, function(event) {
        console.log(`${eventName} event triggered:`, event.detail);
        if (event.detail && event.detail.variant) {
          updatePrice(event.detail.variant);
          updateProductImage(event.detail.variant);
          updateFormInputs(event.detail.variant);
          updateBuyNowButton(event.detail.variant);
        }
      });
    });
    
    // Also listen on the product form
    const productForm = document.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('change', function(event) {
        if (event.target.matches('.as-step-option')) {
          console.log('Product form change detected');
          updateVariantFromOptions();
        }
      });
    }
  }
})();
